<template>
	<div class="page">
		<div class="van-nav-bar van-nav-bar--fixed van-hairline--bottom">
			<div class="left">
				<VanImage
					style="margin-left: 15px"
					round
					width="2rem"
					height="2rem"
					:src="avatar"/>
			</div>
			<div class="van-nav-bar__title van-ellipsis"> 服务市场 </div>
			<div class="right">
				<Icon name="search" size="20" style="margin-right: 15px" @click="onSearchClick"></Icon>
				<Icon name="weapp-nav" style="margin-right: 15px" @click="onMoreClick"></Icon>
			</div>
		</div>
		<div class="fixed-top">
			<NoticeBar
				left-icon="volume-o"
				text="没有我要的服务，或想要入驻服务请联系微信：17165259999"
			/>
			<Search
				v-show="showSearch"
				v-model="value"
				show-action
				placeholder="请输入搜索关键词"
				@search="onSearch"
				>
			  <template #action>
			    <div @click="onSearch">搜索</div>
			  </template>
			</Search>
		</div>
		<div class="page-body" :style="listStyle">
			<PullRefresh v-model="refreshing" @refresh="onRefresh">
        <List v-model="loading" :finished="finished" finished-text="我是有底线的哦" @load="onLoad" sticky>
	        <Cell v-for="(item, index) in list" :key="index" @click="onItemClick(item)">
						<div class="box">
							  <VanImage
								  width="3rem"
								  height="3rem"
								  class="box-left"
								  :src="item.goodsImages[0].imageUrl"/>
							  <div class="box-right">
								  <p class="title">{{ item.goodsInfo.goodsName }}</p>
								  <p class="text"><span>服务费用：{{ item.goodsInfo.price }} / {{item.unit || '天'}}</span><Button round size="small" type="danger" @click.stop="onBuyClick(item)">购买</Button></p>
							  </div>
						  </div>
					</Cell>
        </List>
      </PullRefresh>
		</div>
	</div>
</template>

<script>
	import { NavBar, Image as VanImage, Icon, Cell, Button, NoticeBar, PullRefresh, List, Search } from 'vant'

	export default {
	  components: { NavBar, VanImage, Icon, Cell, Button, NoticeBar, PullRefresh, List, Search },
    data () {
      return {
        value: '',
	      showSearch: false,
	      list: [],
	      page: 1,
	      size: 20,
        error: false,
        loading: false,
        finished: false,
        refreshing: false
      }
    },
		computed: {
	    listStyle() {
	      if(this.showSearch) {
	        return {
	          paddingTop: '140px'
	        }
	      } else {
	        return {
            paddingTop: '90px'
	        }
	      }
	    },
			avatar() {
	      return this.$store.state.userFromJava.headImage;
			}
		},
		mounted() {
	    console.log('market.vue init')
		},
    methods: {
      onBackClick () {},
      onSearchClick () {
        this.showSearch = !this.showSearch
      },
      onMoreClick () {},
      onItemClick(target) {
        this.$router.push({
          name: 'goodDetail',
          query: {
            id: target.goodsInfo.id
          }
        })
      },
      onBuyClick(item) {
        this.$router.push({
          name: 'orderPay',
          params: { ...item }
        })
      },
      onSearch() {
        this.showSearch = false;
        this.refreshing = true;
        this.onRefresh({goodsName: this.value});
      },
      onRefresh(param) {
        this.finished = false;
        this.loading = true;
        this.onLoad(param);
      },
      onLoad(condition) {
        if (this.refreshing) {
          this.page = 1;
          this.list = [];
          this.refreshing = false;
        }

        const targetParam = {
          page: this.page++,
          size: this.size
        };

        this.$store.dispatch('fetchGoods', {...targetParam, ...condition})
          .then(({rows, total}) => {
            this.list = [].concat(this.list, rows);
            this.loading = false;
            if (this.list.length >= total) {
              this.finished = true;
            }
          })
          .catch(() => {
            this.loading = false;
            this.error = true
            this.finished = true;
          })
      },
    }
	}
</script>

<style lang="less" scoped>
	.fixed-top {
		position: fixed;
		top: 46px;
		left: 0;
		right: 0;
		z-index: 2;
	}
	.page {
		height: 100%;
	}

	.van-nav-bar {
		display: flex;
		align-items: center;
		.left {
			display: flex;
			align-items: center;
		}
		.right {
			display: flex;
			align-items: center;
		}
	}

	.page-body {
		padding-top: 90px;
		padding-bottom: 50px;
		box-sizing: border-box;
		height: 100%;

		/deep/.van-pull-refresh {
			min-height: 100%;
		}
	}
</style>
